import {useRef} from "react";

import FormKey from "./FormKey.js";


const useFormKey = () => {
    return useRef(new FormKey()).current;
}

export default useFormKey;